// 'use client';
// import { useState, useEffect, useCallback } from 'react';
// import {
//    Box,
//    Flex,
//    Table,
//    Tbody,
//    Td,
//    Text,
//    Th,
//    Thead,
//    Tr,
//    useColorModeValue,
//    Grid,
//    GridItem,
//    Popover,
//    PopoverTrigger,
//    PopoverContent,
//    PopoverBody,
//    Button,
//    VStack,
//    TabPanel,
//    TabPanels,
//    Tabs,
//    Tab,
//    TabList,
//    MenuList,
//    Menu,
//    MenuButton,
// } from '@chakra-ui/react';
// import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from 'react-icons/md';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//    getB2BSales,
//    getB2CLSales,
//    getB2CSSales,
//    getCDNRSales,
//    getCDNURSales,
//    getEXPSales,
//    getEXEMPSales,
//    getHSNB2BSales,
//    getHSNB2CSales,
//    getDOCSSales,
//    generateAllGSTRReports,
//    downloadGSTRExcelFile,
//    generateGSTRExcel,
//    exportGSTR1Json,
// } from '../../../../redux/actions/reports';
// import Card from 'components/card/Card';
// import nodata from 'assets/img/nfts/no data.svg';
// import back from '../../../../../src/assets/img/nfts/back.svg';
// import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
// import Download from '../../../../assets/img/nfts/download.svg';
// import xls from '../../../../../src/assets/img/nfts/xls.svg';
// import json from '../../../../../src/assets/img/nfts/json.svg';
// import * as XLSX from 'xlsx-js-style';
// import { SHEET_CONFIGS } from 'utils/util';
// import { exportGSTR1ToExcel } from 'utils/util';
// import { exportAllGSTR1Sheets } from 'utils/util';
// import Loading from 'components/loading/Loading';
// import { useUser } from 'contexts';
// import { ChevronDownIcon } from '@chakra-ui/icons';
// // import excel from './GSTR1.xlsx';

// const GSTR1 = () => {
//    const textColor = useColorModeValue('secondaryGray.900', 'white');
//    const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
//    const backgroundColor = useColorModeValue('white', '#101F4A');
//    const [fromDate, setFromDate] = useState('2025-04-14');
//    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
//    const [selected, setSelected] = useState(null);
//    const [selectedOption, setSelectedOption] = useState('B2B');
//    const [isDownloading, setIsDownloading] = useState(false);
//    const [dateRange, setDateRange] = useState(() => {
//       const today = new Date();
//       const sevenDaysAgo = new Date();
//       sevenDaysAgo.setDate(today.getDate() - 6);

//       return {
//          fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
//          toDate: today.toISOString().split('T')[0], // today
//       };
//    });
//    const { user } = useUser();
//    const financialYear = localStorage.getItem('selectedFinancialYear');

//    // Selectors for all report types
//    const B2BSales = useSelector((state) => state.reports?.b2bSales || []);
//    const B2CLSales = useSelector((state) => state.reports?.b2clSales || []);
//    const B2CSSales = useSelector((state) => state.reports?.b2csSales || []);
//    const CDNRSales = useSelector((state) => state.reports?.cdnrSales || []);
//    const CDNURSales = useSelector((state) => state.reports?.cdnurSales || []);
//    const EXPSales = useSelector((state) => state.reports?.expSales || []);
//    const EXEMPSales = useSelector((state) => state.reports?.exempSales || []);
//    const HSNB2BSales = useSelector((state) => state.reports?.hsnB2BSales || []);
//    const HSNB2CSales = useSelector((state) => state.reports?.hsnB2CSales || []);
//    const DOCSSales = useSelector((state) => state.reports?.docsSales || []);

//    const dispatch = useDispatch();

//    const handleDateRangeChange = (dates) => {
//       if (!dates || dates.length !== 2) return;

//       const [from, to] = dates;
//       const formattedFrom = from ? new Date(from).toISOString().split('T')[0] : '';
//       const formattedTo = to ? new Date(to).toISOString().split('T')[0] : '';

//       setDateRange({
//          fromDate: formattedFrom,
//          toDate: formattedTo,
//       });
//    };

//    const reportTypes = {
//       B2B: {
//          data: B2BSales,
//          action: getB2BSales,
//          columns: [
//             { id: 'acc_gstin', header: 'GSTIN/UIN of Recipient', accessor: 'acc_gstin' },
//             { id: 'accountname', header: 'Receiver Name', accessor: 'accountname' },
//             { id: 'docnumber', header: 'Invoice Number', accessor: 'docnumber' },
//             {
//                id: 'txndate',
//                header: 'Invoice Date',
//                accessor: 'txndate',
//                format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
//             },
//             { id: 'netamount', header: 'Invoice Value', accessor: 'netamount' },
//             { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
//             { id: 'reversecharge', header: 'Reverse Charge', accessor: 'reversecharge' },
//             // { id: 'netamount', header: 'Net Amount', accessor: 'netamount' },
//             { id: 'applicableRate', header: 'Applicable % of Tax Rate', accessor: 'applicabletaxrate' },
//             { id: 'invoicetype', header: 'Invoice Type', accessor: 'invoicetype' },
//             { id: 'ecom_cust_gstin', header: 'E-Commerce GSTIN', accessor: 'ecom_cust_gstin' },
//             { id: 'rate', header: 'Rate', accessor: '', staticValue: '18%' },
//             { id: 'taxableamount', header: 'Taxable Value', accessor: 'taxableamount' },
//             { id: 'cess', header: 'Cess Amount', accessor: 'cess' },
//          ],
//       },
//       B2CL: {
//          data: B2CLSales,
//          action: getB2CLSales,
//          columns: [
//             { id: 'invno', header: 'Invoice Number', accessor: 'invno' },
//             {
//                id: 'invoicedate',
//                header: 'Invoice Date',
//                accessor: 'invoicedate',
//                format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
//             },
//             { id: 'invoicevalue', header: 'Invoice Value', accessor: 'invoicevalue' },
//             { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
//             { id: 'applicabletaxrate', header: 'Applicable % of Tax Rate', accessor: 'applicabletaxrate' },
//             { id: 'rate', header: 'Rate', accessor: '', staticValue: '18%' },
//             { id: 'taxableamount', header: 'Taxable Value', accessor: 'taxableamount' },
//             { id: 'cess', header: 'Cess Amount', accessor: 'cess' },
//             { id: 'ecom_cust_gstin', header: 'E-Commerce GSTIN', accessor: 'ecom_cust_gstin' },
//          ],
//       },
//       B2CS: {
//          data: B2CSSales,
//          action: getB2CSSales,
//          columns: [
//             { id: 'type', header: 'Type', accessor: 'type' },
//             { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
//             { id: 'applicabletaxrate', header: 'Applicable % Tax of Rate', accessor: 'applicabletaxrate' },
//             { id: 'rate', header: 'Rate', accessor: '', staticValue: '18%' },
//             { id: 'taxablevalue', header: 'Taxable Value', accessor: 'taxablevalue' },
//             { id: 'cessamount', header: 'Cess Amount', accessor: 'cessamount' },
//             { id: 'ecom_cust_gstin', header: 'E-Commerce GSTIN', accessor: 'ecom_cust_gstin' },
//          ],
//       },
//       CDNR: {
//          data: CDNRSales,
//          action: getCDNRSales,
//          columns: [
//             { id: 'acc_gstin', header: 'GSTIN/UIN of Recipient', accessor: 'acc_gstin' },
//             { id: 'accountname', header: 'Receiver Name', accessor: 'accountname' },
//             { id: 'docnumber', header: 'Note Number ', accessor: 'docnumber' },
//             { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
//             { id: 'reversecharge', header: 'Reverse Charge', accessor: 'reversecharge' },
//             { id: 'applicabletaxrate', header: 'Applicable % of Rate', accessor: 'applicabletaxrate' },
//             { id: 'rate', header: 'Rate', accessor: 'rate' },
//             { id: 'taxableamount', header: 'Taxable Value', accessor: 'taxableamount' },
//             { id: 'cess', header: 'Cess Amount', accessor: 'cess' },
//          ],
//       },
//       CDNUR: {
//          data: CDNURSales,
//          action: getCDNURSales,
//          columns: [
//             { id: 'UR Type', header: 'UR Type', accessor: 'UR Type' },
//             { id: 'Note/Refund Voucher Number', header: 'Note Number', accessor: 'Note/Refund Voucher Number' },
//             {
//                id: 'Note/Refund Voucher Date',
//                header: 'Note Date',
//                accessor: 'Note/Refund Voucher Date',
//                format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
//             },
//             { id: 'Document Type', header: 'Note type', accessor: 'Document Type' },
//             { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
//             { id: 'Note/Refund Voucher Value', header: 'Note Value', accessor: 'Note/Refund Voucher Value' },
//             {
//                id: 'Applicable % of Tax Rate',
//                header: 'Applicable % of Tax Rate',
//                accessor: 'Applicable % of Tax Rate',
//             },
//             { id: 'rate', header: 'Rate', accessor: 'rate' },
//             { id: 'Taxable Value', header: 'Taxable Value', accessor: 'Taxable Value' },
//             { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
//          ],
//       },
//       EXP: {
//          data: EXPSales,
//          action: getEXPSales,
//          columns: [
//             { id: 'exportType', header: 'Export Type', accessor: 'exportType' },
//             { id: 'docnumber', header: 'Invoice Number', accessor: 'docnumber' },
//             {
//                id: 'txndate',
//                header: 'Invoice Date',
//                accessor: 'txndate',
//                format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
//             },
//             { id: 'netAmount', header: 'Invoice Value', accessor: 'netAmount' },
//             { id: 'portCode', header: 'Port Code', accessor: 'portCode' },
//             { id: 'shippingBillNumber', header: 'Shipping Bill Number', accessor: 'shippingBillNumber' },
//             {
//                id: 'shippingBillDate',
//                header: 'Shipping Bill Date',
//                accessor: 'shippingBillDate',
//                format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
//             },
//             { id: 'rate', header: 'Rate', accessor: '', staticValue: '0%' },
//             { id: 'taxableAmount', header: 'Taxable Value', accessor: 'taxableAmount' },
//             { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
//          ],
//       },
//       EXEMP: {
//          data: EXEMPSales,
//          action: getEXEMPSales,
//          columns: [
//             { id: 'description', header: 'Description', accessor: 'description' },
//             { id: 'docnumber', header: 'Nil Rated Supplies', accessor: 'docnumber' },
//             {
//                id: 'txndate',
//                header: 'Exempted',
//                accessor: 'txndate',
//                format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
//             },
//             { id: 'netAmount', header: 'Non-GST Supplies', accessor: 'netAmount' },
//          ],
//       },
//       HSNB2B: {
//          data: HSNB2BSales,
//          action: getHSNB2BSales,
//          columns: [
//             { id: 'Description', header: 'HSN Code', accessor: 'Description' },
//             { id: 'Description', header: 'Description', accessor: 'Description' },
//             { id: 'UQC', header: 'UQC', accessor: 'UQC' },
//             { id: 'Total Quantity', header: 'Total Quantity', accessor: 'Total Quantity' },
//             { id: 'Total Value', header: 'Total Value', accessor: 'Total Value' },
//             { id: 'Rate', header: 'Rate', accessor: 'Rate' },
//             { id: 'Taxable Value', header: 'Taxable Value', accessor: 'Taxable Value' },
//             { id: 'Integrated Tax Amount', header: 'Integrated Tax Amount', accessor: 'Integrated Tax Amount' },
//             { id: 'Central Tax Amount', header: 'Central Tax Amount', accessor: 'Central Tax Amount' },
//             { id: 'State/UT Tax Amount', header: 'State/UT Tax Amount', accessor: 'State/UT Tax Amount' },
//             { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
//          ],
//       },
//       HSNB2C: {
//          data: HSNB2CSales,
//          action: getHSNB2CSales,
//          columns: [
//             { id: 'Description', header: 'HSN Code', accessor: 'Description' },
//             { id: 'Description', header: 'Description', accessor: 'Description' },
//             { id: 'UQC', header: 'UQC', accessor: 'UQC' },
//             { id: 'Total Quantity', header: 'Total Quantity', accessor: 'Total Quantity' },
//             { id: 'Total Value', header: 'Total Value', accessor: 'Total Value' },
//             { id: 'Rate', header: 'Rate', accessor: 'Rate' },
//             { id: 'Taxable Value', header: 'Taxable Value', accessor: 'Taxable Value' },
//             { id: 'Integrated Tax Amount', header: 'Integrated Tax Amount', accessor: 'Integrated Tax Amount' },
//             { id: 'Central Tax Amount', header: 'Central Tax Amount', accessor: 'Central Tax Amount' },
//             { id: 'State/UT Tax Amount', header: 'State/UT Tax Amount', accessor: 'State/UT Tax Amount' },
//             { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
//          ],
//       },
//       DOCS: {
//          data: DOCSSales,
//          action: getDOCSSales,
//          columns: [
//             { id: 'Nature  of Document', header: 'Nature of Document', accessor: 'Nature  of Document' },
//             { id: 'Sr. No. From', header: 'Sr. No. From', accessor: 'Sr. No. From' },
//             { id: 'Sr. No. To', header: 'Sr. No. To', accessor: 'Sr. No. To' },
//             { id: 'Total Number', header: 'Total Number', accessor: 'Total Number' },
//             { id: 'CANCELLED', header: 'Cancelled', accessor: 'CANCELLED', format: (val) => (val ? 'Yes' : 'No') },
//          ],
//       },
//    };
//    const companyId = (user && user?.loginhistory?.companyId) || localStorage.getItem('companyId');

//    useEffect(() => {
//       if (!companyId) {
//          console.error('Company ID not found in localStorage');
//          return;
//       }

//       const currentReport = reportTypes[selectedOption];
//       if (currentReport?.action && user && user?.loginhistory?.companyId) {
//          dispatch(
//             currentReport.action({
//                companyId: user && user?.loginhistory?.companyId,
//                fromDate: dateRange?.fromDate || fromDate,
//                toDate: dateRange?.toDate || toDate,
//             }),
//          );
//       }
//    }, [dispatch, selectedOption, dateRange, fromDate, toDate, companyId]);

//    // Alternative: Download all reports at once
//    const downloadAllReports = async () => {
//       setIsDownloading(true);

//       try {
//          const requestData = {
//             gstNumber: 'currentGstNumber',
//             dateRange: {
//                fromDate: dateRange?.fromDate || fromDate,
//                toDate: dateRange?.toDate || toDate,
//             },
//             companyId,
//          };

//          const result = await dispatch(generateAllGSTRReports(requestData));

//          // Show summary of generated reports
//          const { results, successCount, totalReports } = result;
//          console.log('Generated Reports:', results);

//          // Optionally download each successful report
//          for (const report of results) {
//             if (report.success && report.filePath) {
//                await dispatch(downloadGSTRExcelFile(report.fileName, report.filePath));
//             }
//          }
//       } catch (error) {
//          console.error('Error generating all reports:', error);
//          alert(`Error generating reports: ${error.message}`);
//       } finally {
//          setIsDownloading(false);
//       }
//    };
//    const downloadExcel = async () => {
//       const currentReport = reportTypes[selectedOption];
//       // if (!currentReport || currentReport.data.length === 0) {
//       //    alert('No data available to download');
//       //    return;
//       // }
//       setIsDownloading(true);

//       try {
//          await exportGSTR1ToExcel(selectedOption, currentReport.data, {
//             fromDate: dateRange?.fromDate || fromDate,
//             toDate: dateRange?.toDate || toDate,
//          });
//       } catch (error) {
//          console.error('Error downloading Excel:', error);
//          alert(`Error downloading Excel: ${error.message}`);
//       } finally {
//          setIsDownloading(false); // Stop loading
//       }
//    };

//    const generateEnhancedJSON = (gstr3bData, baseGstData = {}) => {
//       // Initialize the GST return structure
//       const gstReturn = {
//          gstin: baseGstData.gstin || '',
//          fp: baseGstData.fp || '',
//          b2b: [],
//          b2cl: [],
//          b2cs: [],
//          cdnr: [],
//          cdnur: [],
//          exp: [],
//          hsn: {
//             hsn_b2b: [],
//             hsn_b2c: [],
//          },
//          doc_issue: baseGstData.doc_issue || {
//             doc_det: [],
//          },
//       };

//       // Helper function to safely get value
//       const getValue = (value) => {
//          if (value === null || value === undefined || value === '') return 0;
//          return Number(value) || 0;
//       };

//       // Helper function to generate invoice number
//       const generateInvoiceNumber = (index, type = 'SI') => {
//          const date = new Date();
//          const year = date.getFullYear().toString().slice(-2);
//          const nextYear = (date.getFullYear() + 1).toString().slice(-2);
//          return `${type}-${year}-${nextYear}-${(index + 1).toString().padStart(3, '0')}`;
//       };

//       // Helper function to generate GSTIN
//       const generateGSTIN = (stateCode = '24', index = 0) => {
//          const prefixes = ['BTCPP', 'ABRPG', 'DDIPM', 'ACOPJ', 'FNRPS', 'BBIPT', 'GUEPM'];
//          const numbers = ['5520Q3ZA', '1554H1ZP', '9620J1Z9', '1707D1Z0', '1470K1ZD', '5789F1Z3', '9783G1Z2'];
//          const prefix = prefixes[index % prefixes.length] || 'ABCDE';
//          const number = numbers[index % numbers.length] || '1234A1B2';
//          return `${stateCode}${prefix}${number}`;
//       };

//       // Helper function to create B2B entry
//       const createB2BEntry = (gstr3bEntry, index, isCredit = false) => {
//          const taxableValue = getValue(gstr3bEntry.taxable_value);
//          const cgstAmount = getValue(gstr3bEntry.cgst_amount);
//          const sgstAmount = getValue(gstr3bEntry.sgst_amount);
//          const igstAmount = getValue(gstr3bEntry.igst_amount);

//          // Skip if no taxable value
//          if (taxableValue === 0 && cgstAmount === 0 && sgstAmount === 0 && igstAmount === 0) {
//             return null;
//          }

//          // Calculate rate based on tax amounts
//          const totalTax = cgstAmount + sgstAmount + igstAmount;
//          const rate = taxableValue > 0 ? Math.round((totalTax / taxableValue) * 100) : 5;

//          const invoiceValue = taxableValue + totalTax;
//          const invoiceNumber = generateInvoiceNumber(index);
//          const gstin = generateGSTIN('24', index);

//          const entry = {
//             ctin: gstin,
//          };

//          if (isCredit) {
//             // Create credit note structure
//             entry.nt = [
//                {
//                   val: Math.abs(invoiceValue),
//                   ntty: 'C',
//                   nt_num: `SI-RT-${index + 34}`,
//                   nt_dt: new Date().toLocaleDateString('en-GB').replace(/\//g, '-'),
//                   pos: '24',
//                   rchrg: 'N',
//                   inv_typ: 'R',
//                   itms: [
//                      {
//                         num: 1,
//                         itm_det: {
//                            txval: Math.abs(taxableValue),
//                            rt: rate,
//                            iamt: Math.abs(igstAmount),
//                            camt: Math.abs(cgstAmount),
//                            samt: Math.abs(sgstAmount),
//                            csamt: 0,
//                         },
//                      },
//                   ],
//                },
//             ];
//          } else {
//             // Create regular invoice structure
//             entry.inv = [
//                {
//                   inum: invoiceNumber,
//                   idt: new Date().toLocaleDateString('en-GB').replace(/\//g, '-'),
//                   val: invoiceValue,
//                   pos: '24',
//                   rchrg: 'N',
//                   inv_typ: 'R',
//                   itms: [
//                      {
//                         num: 1,
//                         itm_det: {
//                            txval: taxableValue,
//                            rt: rate,
//                            iamt: igstAmount,
//                            camt: cgstAmount,
//                            samt: sgstAmount,
//                            csamt: 0,
//                         },
//                      },
//                   ],
//                },
//             ];
//          }

//          return entry;
//       };

//       // Helper function to create HSN entry
//       const createHSNEntry = (gstr3bEntry, index, type = 'b2b') => {
//          const taxableValue = getValue(gstr3bEntry.taxable_value);
//          const cgstAmount = getValue(gstr3bEntry.cgst_amount);
//          const sgstAmount = getValue(gstr3bEntry.sgst_amount);
//          const igstAmount = getValue(gstr3bEntry.igst_amount);

//          if (taxableValue === 0 && cgstAmount === 0 && sgstAmount === 0 && igstAmount === 0) {
//             return null;
//          }

//          // Calculate rate
//          const totalTax = cgstAmount + sgstAmount + igstAmount;
//          const rate = taxableValue > 0 ? Math.round((totalTax / taxableValue) * 100) : 5;

//          // HSN codes and descriptions
//          const hsnCodes = ['5404', '540710', '6204', '6109', '5208'];
//          const descriptions = ['YAMINI', 'aKSHARA (VI)', 'COTTON FABRIC', 'T-SHIRTS', 'WOVEN FABRIC'];
//          const uqcs = ['QTL', 'PCS', 'MTR', 'PCS', 'MTR'];

//          const hsnCode = hsnCodes[index % hsnCodes.length];
//          const description = descriptions[index % descriptions.length];
//          const uqc = uqcs[index % uqcs.length];

//          // Calculate approximate quantity
//          const avgPrice = taxableValue > 0 ? Math.max(1, Math.round(taxableValue / 100)) : 100;
//          const qty = Math.max(1, Math.round(taxableValue / avgPrice));

//          return {
//             num: index + 1,
//             hsn_sc: type === 'b2c' ? hsnCode + '10' : hsnCode,
//             txval: taxableValue,
//             iamt: igstAmount,
//             camt: cgstAmount,
//             samt: sgstAmount,
//             csamt: 0,
//             desc: '',
//             user_desc: type === 'b2c' ? '' : description,
//             uqc: uqc,
//             qty: qty,
//             rt: rate,
//          };
//       };

//       // Process GSTR3B data dynamically
//       if (Array.isArray(gstr3bData)) {
//          let b2bIndex = 0;
//          let hsnB2BIndex = 0;
//          let hsnB2CIndex = 0;
//          let b2clIndex = 0;
//          let b2csIndex = 0;

//          gstr3bData.forEach((entry, index) => {
//             const subpara = entry.subpara || '';
//             const para = entry.para || '';
//             const taxableValue = getValue(entry.taxable_value);

//             // Skip null/empty entries
//             if (taxableValue === 0 && getValue(entry.total_tax) === 0) {
//                return;
//             }

//             // Process based on subpara content
//             if (
//                subpara.includes('Outward taxable supplies') &&
//                !subpara.includes('zero rated') &&
//                !subpara.includes('Exempted')
//             ) {
//                // Main B2B supplies - split into multiple entries for realism
//                const numEntries = Math.min(5, Math.max(1, Math.floor(taxableValue / 10000)));
//                const valuePerEntry = taxableValue / numEntries;
//                const cgstPerEntry = getValue(entry.cgst_amount) / numEntries;
//                const sgstPerEntry = getValue(entry.sgst_amount) / numEntries;
//                const igstPerEntry = getValue(entry.igst_amount) / numEntries;

//                for (let i = 0; i < numEntries; i++) {
//                   const b2bEntry = createB2BEntry(
//                      {
//                         taxable_value: valuePerEntry,
//                         cgst_amount: cgstPerEntry,
//                         sgst_amount: sgstPerEntry,
//                         igst_amount: igstPerEntry,
//                      },
//                      b2bIndex + i,
//                   );

//                   if (b2bEntry) {
//                      gstReturn.b2b.push(b2bEntry);
//                   }
//                }
//                b2bIndex += numEntries;

//                // Add corresponding HSN B2B entry
//                const hsnEntry = createHSNEntry(entry, hsnB2BIndex, 'b2b');
//                if (hsnEntry) {
//                   gstReturn.hsn.hsn_b2b.push(hsnEntry);
//                   hsnB2BIndex++;
//                }
//             } else if (subpara.includes('zero rated') && taxableValue !== 0) {
//                // Zero rated supplies - add to HSN B2C
//                const hsnEntry = createHSNEntry(entry, hsnB2CIndex, 'b2c');
//                if (hsnEntry) {
//                   gstReturn.hsn.hsn_b2c.push(hsnEntry);
//                   hsnB2CIndex++;
//                }
//             } else if (subpara.includes('B2CL') || para.includes('Unregistered Persons')) {
//                // B2CL entries
//                const b2clEntry = createB2BEntry(entry, b2clIndex);
//                if (b2clEntry) {
//                   // Modify for B2CL structure (no GSTIN)
//                   delete b2clEntry.ctin;
//                   b2clEntry.pos = '24';
//                   if (b2clEntry.inv) {
//                      b2clEntry.inv[0].pos = '24';
//                      b2clEntry.inv[0].val = getValue(entry.taxable_value) + getValue(entry.total_tax);
//                   }
//                   gstReturn.b2cl.push(b2clEntry);
//                   b2clIndex++;
//                }
//             } else if (subpara.includes('B2CS')) {
//                // B2CS entries
//                const rate =
//                   getValue(entry.total_tax) > 0
//                      ? Math.round((getValue(entry.total_tax) / getValue(entry.taxable_value)) * 100)
//                      : 5;

//                const b2csEntry = {
//                   pos: '24',
//                   txval: getValue(entry.taxable_value),
//                   rt: rate,
//                   iamt: getValue(entry.igst_amount),
//                   camt: getValue(entry.cgst_amount),
//                   samt: getValue(entry.sgst_amount),
//                   csamt: 0,
//                };

//                gstReturn.b2cs.push(b2csEntry);
//                b2csIndex++;
//             } else if (subpara.includes('Credit') || subpara.includes('Debit')) {
//                // Credit/Debit notes
//                const creditEntry = createB2BEntry(entry, b2bIndex, true);
//                if (creditEntry) {
//                   gstReturn.b2b.push(creditEntry);
//                   b2bIndex++;
//                }
//             } else if (subpara.includes('Export')) {
//                // Export entries
//                const expEntry = createB2BEntry(entry, 0);
//                if (expEntry && expEntry.inv) {
//                   expEntry.inv[0].exp_typ = 'WPAY';
//                   expEntry.inv[0].port_cd = 'INMAA4';
//                   gstReturn.exp.push(expEntry);
//                }
//             }
//          });
//       }

//       // Add document issue details if B2B entries exist
//       if (gstReturn.b2b.length > 0 && (!baseGstData.doc_issue || !baseGstData.doc_issue.doc_det)) {
//          const firstInvoice = gstReturn.b2b.find((entry) => entry.inv)?.inv[0]?.inum;
//          const lastInvoice = gstReturn.b2b[gstReturn.b2b.length - 1]?.inv?.[0]?.inum;

//          if (firstInvoice) {
//             gstReturn.doc_issue = {
//                doc_det: [
//                   {
//                      doc_num: 1,
//                      docs: [
//                         {
//                            cancel: 0,
//                            from: firstInvoice,
//                            net_issue: gstReturn.b2b.length,
//                            num: 1,
//                            to: lastInvoice || firstInvoice,
//                            totnum: gstReturn.b2b.length,
//                         },
//                      ],
//                   },
//                ],
//             };
//          }
//       }

//       // Clean up empty sections
//       if (gstReturn.b2cl.length === 0) delete gstReturn.b2cl;
//       if (gstReturn.b2cs.length === 0) delete gstReturn.b2cs;
//       if (gstReturn.cdnr.length === 0) delete gstReturn.cdnr;
//       if (gstReturn.cdnur.length === 0) delete gstReturn.cdnur;
//       if (gstReturn.exp.length === 0) delete gstReturn.exp;
//       if (gstReturn.hsn.hsn_b2b.length === 0 && gstReturn.hsn.hsn_b2c.length === 0) {
//          delete gstReturn.hsn;
//       } else {
//          if (gstReturn.hsn.hsn_b2b.length === 0) delete gstReturn.hsn.hsn_b2b;
//          if (gstReturn.hsn.hsn_b2c.length === 0) delete gstReturn.hsn.hsn_b2c;
//       }

//       return gstReturn;
//    };

//    // Function to download JSON
//    const downloadJSON = (data, filename = 'gst_return_data.json') => {
//       const jsonString = JSON.stringify(data, null, 2);
//       const blob = new Blob([jsonString], { type: 'application/json' });
//       const url = URL.createObjectURL(blob);

//       const a = document.createElement('a');
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);

//       URL.revokeObjectURL(url);

//       console.log(`Downloaded: ${filename}`);
//    };

//    // Complete handler function for your button
//    const handleGenerateEnhancedJSON = (gstr3bData, baseGstData = {}) => {
//       try {
//          if (!Array.isArray(gstr3bData) || gstr3bData.length === 0) {
//             console.error('Invalid GSTR3B data provided');
//             alert('Invalid GSTR3B data. Please provide valid array of GSTR3B entries.');
//             return {};
//          }

//          console.log('Processing GSTR3B data:', gstr3bData);

//          // Generate the GST return JSON
//          const gstReturnData = generateEnhancedJSON(gstr3bData, baseGstData);

//          // Create filename
//          const timestamp = new Date().toISOString().split('T')[0];
//          const filename = `gst_return_${gstReturnData.gstin || 'converted'}_${
//             gstReturnData.fp || timestamp.replace(/-/g, '')
//          }.json`;

//          // Download the JSON file
//          downloadJSON(gstReturnData, filename);

//          console.log('GST Return JSON generated successfully');
//          console.log('Generated structure:', Object.keys(gstReturnData));
//          console.log('B2B entries:', gstReturnData.b2b?.length || 0);

//          return gstReturnData;
//       } catch (error) {
//          console.error('Error generating GST Return JSON:', error);
//          alert('Error generating JSON file. Check console for details.');
//          return {};
//       }
//    };

//    const onDownloadJson = useCallback(async () => {
//       const res = await dispatch(exportGSTR1Json({ companyId, fromDate: '2025-10-01', toDate: '2025-10-31' }));
//       const jsonString = JSON.stringify(res, null, 2);
//       const blob = new Blob([jsonString], { type: 'application/json' });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `${res.gstin}_GSTR1.json`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
//    }, [companyId, dispatch]);

//    const Dynamicoption = ({ setSelectedOption, selectedOption }) => {
//       const options = Object.keys(reportTypes);
//       const tabs = options.map((option) => ({ value: option, label: option }));
//       const currentIndex = options.indexOf(selectedOption);

//       const prevTab = currentIndex > 0 ? { value: options[currentIndex - 1], label: options[currentIndex - 1] } : null;
//       const nextTab =
//          currentIndex < options.length - 1
//             ? { value: options[currentIndex + 1], label: options[currentIndex + 1] }
//             : null;

//       const mobilePrevTab = prevTab;
//       const mobileNextTab = nextTab;

//       const getTabletTabs = () => {
//          if (tabs.length <= 5) return tabs;
//          if (currentIndex < 2) {
//             return tabs.slice(0, 5);
//          } else if (currentIndex > tabs.length - 3) {
//             return tabs.slice(tabs.length - 5);
//          } else {
//             return tabs.slice(currentIndex - 2, currentIndex + 3);
//          }
//       };

//       const tabletTabs = getTabletTabs();

//       const handleClick = (option) => {
//          setSelectedOption(option);
//       };

//       const MobileNavigation = () => (
//          <>
//             <Box
//                display={{ base: 'flex', md: 'none' }}
//                justifyContent="space-between"
//                alignItems="center"
//                p={2}
//                bg={backgroundColor}
//                borderRadius="7px"
//                mt={2}>
//                <Box
//                   as="div"
//                   display="flex"
//                   alignItems="center"
//                   fontSize="14px"
//                   width="30%"
//                   justifyContent="flex-start"
//                   fontWeight={500}
//                   gap={5}>
//                   {mobilePrevTab && (
//                      <>
//                         <Box
//                            as="span"
//                            cursor={mobilePrevTab ? 'pointer' : 'not-allowed'}
//                            opacity={mobilePrevTab ? 1 : 0.5}
//                            onClick={() => mobilePrevTab && handleClick(mobilePrevTab.value)}>
//                            <MdOutlineNavigateBefore size={20} />
//                         </Box>
//                         <Box as="span" ml={1}>
//                            {mobilePrevTab.label}
//                         </Box>
//                      </>
//                   )}
//                </Box>

//                <Box
//                   fontWeight={500}
//                   fontSize={14}
//                   borderRadius="full"
//                   py={2}
//                   px={4}
//                   textAlign="center"
//                   width="30%"
//                   className="active">
//                   {selectedOption}
//                </Box>

//                <Box
//                   as="div"
//                   display="flex"
//                   alignItems="center"
//                   fontSize="14px"
//                   width="30%"
//                   justifyContent="flex-end"
//                   fontWeight={500}
//                   gap={5}>
//                   {mobileNextTab && (
//                      <>
//                         <Box as="span" mr={1}>
//                            {mobileNextTab.label}
//                         </Box>
//                         <Box
//                            as="span"
//                            cursor={mobileNextTab ? 'pointer' : 'not-allowed'}
//                            opacity={mobileNextTab ? 1 : 0.5}
//                            onClick={() => mobileNextTab && handleClick(mobileNextTab.value)}>
//                            <MdOutlineNavigateNext size={20} />
//                         </Box>
//                      </>
//                   )}
//                </Box>
//             </Box>

//             <Flex
//                display={{ base: 'none', md: 'flex', lg: 'none' }}
//                justifyContent="space-between"
//                alignItems="center"
//                p={2}
//                bg={backgroundColor}
//                borderRadius="7px"
//                mt={2}>
//                <Box
//                   as="span"
//                   cursor={currentIndex > 0 ? 'pointer' : 'not-allowed'}
//                   opacity={currentIndex > 0 ? 1 : 0.5}
//                   onClick={() => currentIndex > 0 && handleClick(options[currentIndex - 1])}
//                   mx={2}>
//                   <MdOutlineNavigateBefore size={20} />
//                </Box>

//                {tabletTabs.map((tab) => (
//                   <Box
//                      key={tab.value}
//                      fontWeight={500}
//                      fontSize={14}
//                      borderRadius="full"
//                      py={2}
//                      px={4}
//                      textAlign="center"
//                      className={tab.value === selectedOption ? 'active' : ''}
//                      cursor="pointer"
//                      onClick={() => handleClick(tab.value)}
//                      flex={1}>
//                      {tab.label}
//                   </Box>
//                ))}

//                <Box
//                   as="span"
//                   cursor={currentIndex < options.length - 1 ? 'pointer' : 'not-allowed'}
//                   opacity={currentIndex < options.length - 1 ? 1 : 0.5}
//                   onClick={() => currentIndex < options.length - 1 && handleClick(options[currentIndex + 1])}
//                   mx={2}>
//                   <MdOutlineNavigateNext size={20} />
//                </Box>
//             </Flex>
//          </>
//       );

//       return (
//          <>
//             <MobileNavigation />

//             <Box display={{ base: 'none', md: 'none', lg: 'flex' }} bg={backgroundColor} borderRadius="7px" p={1}>
//                <Table>
//                   <Thead>
//                      <Tr display={'flex'}>
//                         {options.map((option, index) => (
//                            <Text
//                               key={index}
//                               textAlign="Center"
//                               borderRadius="full"
//                               w={'100%'}
//                               py={2}
//                               className={selectedOption === option ? 'active' : ''}
//                               style={{
//                                  borderTop: '0px',
//                                  borderRight: '0px',
//                                  borderBottom: selectedOption === option ? 'active' : '1px solid transparent',
//                                  borderLeft: '0px',
//                                  cursor: 'pointer',
//                               }}
//                               onClick={() => setSelectedOption(option)}>
//                               <button
//                                  style={{
//                                     fontWeight: '500',
//                                     fontSize: '15px',
//                                  }}>
//                                  {option}
//                               </button>
//                            </Text>
//                         ))}
//                      </Tr>
//                   </Thead>
//                </Table>
//             </Box>
//          </>
//       );
//    };

//    const DynamicSummary = ({ data }) => {
//       const totalInvoices = data.length;
//       const totalInvoiceValue = data.reduce((sum, invoice) => sum + (parseFloat(invoice.netAmount) || 0), 0);
//       const totalTaxableValue = data.reduce((sum, taxable) => sum + (parseFloat(taxable.taxableAmount) || 0), 0);

//       return (
//          <Box bg={backgroundColor} borderRadius={'7px'} p={3}>
//             <Flex>
//                <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%">
//                   Summary
//                </Text>
//             </Flex>

//             <Flex marginTop="20px">
//                <Flex gap="120px" borderRight="2px solid" paddingRight="30px">
//                   <div className="text-center">
//                      <Text fontSize={'14px'} fontWeight={600}>
//                         No. of {selectedOption === 'B2B' ? 'Recipients' : 'Invoices'}
//                      </Text>
//                      <Text fontSize={'14px'} fontWeight={600}>
//                         {data.length}
//                      </Text>
//                   </div>

//                   <div className="text-center">
//                      <Text fontSize={'14px'} fontWeight={600}>
//                         No. of Invoices
//                      </Text>
//                      <Text fontSize={'14px'} fontWeight={600}>
//                         {totalInvoices}
//                      </Text>
//                   </div>
//                </Flex>

//                <div className="border-l h-12 mx-4"></div>

//                <Flex gap="120px" paddingLeft="30px">
//                   <div className="text-center">
//                      <Text fontSize={'14px'} fontWeight={600}>
//                         Total Invoice Value
//                      </Text>
//                      <div className="flex items-center gap-2">
//                         <Text fontSize={'14px'} fontWeight={600}>
//                            ₹{totalInvoiceValue.toFixed(2)}
//                         </Text>
//                      </div>
//                   </div>

//                   <div className="text-center">
//                      <Text fontSize={'14px'} fontWeight={600}>
//                         Total Taxable Value
//                      </Text>
//                      <div className="flex items-center gap-2">
//                         <Text fontSize={'14px'} fontWeight={600}>
//                            ₹{totalTaxableValue.toFixed(2)}
//                         </Text>
//                      </div>
//                   </div>
//                </Flex>
//             </Flex>
//          </Box>
//       );
//    };

//    const renderTable = () => {
//       const currentReport = reportTypes[selectedOption];
//       if (!currentReport) return null;

//       return (
//          <Card mt="15px" borderRadius="7px">
//             <Box overflowX="auto" className="custom-scrollbar" position="relative" minH={'60vh'} maxH={'60vh'}>
//                <Table variant="simple" color="gray.500" mb="24px" mt="12px">
//                   <Thead>
//                      <Tr>
//                         {currentReport.columns.map((column, index) => (
//                            <Th key={index} borderColor={borderColor}>
//                               {column.header}
//                            </Th>
//                         ))}
//                      </Tr>
//                   </Thead>
//                   <Tbody>
//                      {currentReport.data.length === 0 ? (
//                         <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
//                            <Td
//                               colSpan={currentReport.columns.length}
//                               justifyContent="center"
//                               alignItems="center"
//                               width="100%">
//                               <Grid justifyContent="center" alignItems="center" gap={9}>
//                                  <img src={nodata} alt="No Data Found" width="200px" height="200px" />
//                                  <GridItem justifySelf="center">
//                                     <label>No {selectedOption} data found</label>
//                                  </GridItem>
//                               </Grid>
//                            </Td>
//                         </Tr>
//                      ) : (
//                         currentReport.data.map((row, rowIndex) => (
//                            <Tr key={rowIndex} _hover={{ bg: 'rgba(0, 63, 140, 0.08)' }}>
//                               {currentReport.columns.map((column, colIndex) => (
//                                  <Td key={colIndex} borderColor="gray.200">
//                                     {column.accessor
//                                        ? column.format
//                                           ? column.format(row[column.accessor])
//                                           : row[column.accessor] !== undefined
//                                           ? row[column.accessor]
//                                           : '-'
//                                        : column.staticValue || '-'}
//                                  </Td>
//                               ))}
//                            </Tr>
//                         ))
//                      )}
//                   </Tbody>
//                </Table>
//             </Box>
//          </Card>
//       );
//    };

//    const MonthQuarterDropdown = ({ setDateRange, selected, setSelected }) => {
//       // const [selected, setSelected] = useState(null);

//       const financialYear = localStorage.getItem('selectedFinancialYear');

//       const [startYear, endYear] = financialYear?.split('-').map((y) => parseInt(y.trim(), 10));

//       const months = [
//          `April ${startYear}`,
//          `May ${startYear}`,
//          `June ${startYear}`,
//          `July ${startYear}`,
//          `August ${startYear}`,
//          `September ${startYear}`,
//          `October ${startYear}`,
//          `November ${startYear}`,
//          `December ${startYear}`,
//          `January ${endYear}`,
//          `February ${endYear}`,
//          `March ${endYear}`,
//       ];

//       const quarters = [
//          `Q1  ( April ${startYear} - June ${startYear} )`,
//          `Q2  ( July ${startYear} - September ${startYear} )`,
//          `Q3  ( October ${startYear} - December ${startYear} )`,
//          `Q4 ( January ${endYear} - March ${endYear} )`,
//       ];

//       const handleDateRangeChange = (option, type) => {
//          console.log('date option', option, type);
//          if (type === 'month') {
//             const [monthName, year] = option.split(' ');

//             const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
//             const fromDate = new Date(year, monthIndex, 1, 0, 0, 1);
//             const toDate = new Date(year, monthIndex + 1, 0);

//             setDateRange({
//                fromDate: fromDate.toLocaleDateString('en-CA'),
//                toDate: toDate.toLocaleDateString('en-CA'),
//             });
//          }
//          if (type === 'quarter') {
//             const match = option.match(/\((.*?)\)/);
//             if (match) {
//                const [startStr, endStr] = match[1].split('-').map((s) => s.trim());

//                const [startMonthName, startYear] = startStr.split(' ');
//                const startMonthIndex = new Date(`${startMonthName} 1, ${startYear}`).getMonth();
//                const fromDate = new Date(startYear, startMonthIndex, 1, 0, 0, 1);

//                const [endMonthName, endYear] = endStr.split(' ');
//                const endMonthIndex = new Date(`${endMonthName} 1, ${endYear}`).getMonth();
//                const toDate = new Date(endYear, endMonthIndex + 1, 0, 23, 59, 59);

//                setDateRange({
//                   fromDate: fromDate.toLocaleDateString('en-CA'),
//                   toDate: toDate.toLocaleDateString('en-CA'),
//                });
//             }
//          }
//          setSelected(option);
//       };

//       return (
//          <Box>
//             <Menu closeOnSelect={false}>
//                {({ onClose }) => (
//                   <>
//                      <MenuButton
//                         as={Button}
//                         rightIcon={<ChevronDownIcon />}
//                         width="250px"
//                         justifyContent="space-between"
//                         textAlign="left">
//                         {selected || 'Select Option'}
//                      </MenuButton>

//                      <MenuList p={0} minW="250px">
//                         <Tabs isFitted variant="enclosed">
//                            <TabList>
//                               <Tab>Month</Tab>
//                               <Tab>Quarter</Tab>
//                            </TabList>

//                            <TabPanels>
//                               <TabPanel maxH="400px" overflowY="auto" p={0}>
//                                  <VStack align="stretch" gap={0}>
//                                     {months.map((month) => (
//                                        <Button
//                                           key={month}
//                                           variant="ghost"
//                                           justifyContent="flex-start"
//                                           borderRadius={0}
//                                           onClick={() => {
//                                              handleDateRangeChange(month, 'month');
//                                              setSelected(month);
//                                              onClose();
//                                           }}
//                                           _hover={{ bg: 'blue.100' }}>
//                                           {month}
//                                        </Button>
//                                     ))}
//                                  </VStack>
//                               </TabPanel>

//                               <TabPanel maxH="400px" overflowY="auto" p={0}>
//                                  <VStack align="stretch" gap={0}>
//                                     {quarters.map((q) => (
//                                        <Button
//                                           key={q}
//                                           variant="ghost"
//                                           justifyContent="flex-start"
//                                           borderRadius={0}
//                                           onClick={() => {
//                                              handleDateRangeChange(q, 'quarter');
//                                              setSelected(q);
//                                              onClose();
//                                           }}
//                                           _hover={{ bg: 'blue.100' }}>
//                                           {q}
//                                        </Button>
//                                     ))}
//                                  </VStack>
//                               </TabPanel>
//                            </TabPanels>
//                         </Tabs>
//                      </MenuList>
//                   </>
//                )}
//             </Menu>
//          </Box>
//       );
//    };

//    return (
//       <>
//          <Flex pr="25px" mb="8px" justifyContent="space-between" align="center" mt="30px" overflow={'hidden'}>
//             <Flex>
//                <img
//                   src={back}
//                   alt="Go Back"
//                   width="15px"
//                   onClick={() => window.history.back()}
//                   style={{ cursor: 'pointer' }}
//                />
//                <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
//                   GSTR1
//                </Text>
//             </Flex>
//             <Flex alignItems={'end'} mt={3}>
//                {financialYear === 'ALL' ? (
//                   <PeriodDatePicker
//                      value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
//                      onChange={handleDateRangeChange}
//                      defaultPeriod="lastMonth"
//                      style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
//                   />
//                ) : (
//                   <MonthQuarterDropdown setDateRange={setDateRange} selected={selected} setSelected={setSelected} />
//                )}
//                <Flex>
//                   <Popover>
//                      <PopoverTrigger>
//                         {/* Image as Clickable Button */}
//                         <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
//                      </PopoverTrigger>

//                      <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
//                         <PopoverBody p="3">
//                            {/* <button onClick={downloadExcel} disabled={isDownloading} className="btn btn-primary">
//                               {isDownloading ? 'Generating...' : `Download ${selectedOption} Excel`}
//                            </button>

//                            <button
//                               onClick={downloadAllReports}
//                               disabled={isDownloading}
//                               className="btn btn-secondary ml-2">
//                               {isDownloading ? 'Generating...' : 'Download All Reports'}
//                            </button> */}

//                            <Button
//                               width="100%"
//                               variant="ghost"
//                               _hover={{ bg: 'blue.100' }}
//                               onClick={downloadExcel}
//                               // onClick={downloadAllReports}
//                               justifyContent="space-between"
//                               mb={3}>
//                               <img src={xls} alt="Download XLS" width="30px"></img>
//                               Download Execl
//                            </Button>
//                            <Button
//                               width="100%"
//                               variant="ghost"
//                               _hover={{ bg: 'blue.100' }}
//                               //     onClick={() =>
//                               //    handleGenerateEnhancedJSON(gstr3bData, {
//                               //       gstin: '24BTCPP5520Q3ZA',
//                               //       fp: '072025',
//                               //    })
//                               // }
//                               // onClick={downloadAllReportsJSON}
//                               // onClick={() => alert('Option 2 Selected')}
//                               onClick={() => onDownloadJson()}
//                               justifyContent="space-between">
//                               <img src={json} alt="Download json" width="30px" mr></img>
//                               Download JSON
//                            </Button>
//                         </PopoverBody>
//                      </PopoverContent>
//                   </Popover>
//                </Flex>
//             </Flex>
//          </Flex>

//          <div mt="15px">
//             <Dynamicoption selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
//          </div>

//          <Grid overflow="auto">
//             <Box mt="15px">
//                <DynamicSummary data={reportTypes[selectedOption]?.data || []} />
//             </Box>
//             {renderTable()}
//          </Grid>
//          {isDownloading && (
//             <Flex
//                justify="center"
//                align="center"
//                position="fixed"
//                top="0"
//                left="0"
//                width="100vw"
//                height="100vh"
//                bg="rgba(0, 0, 0, 0.4)"
//                zIndex="9999">
//                <Flex p={8} bg="white" borderRadius="md" boxShadow="lg">
//                   <Loading />
//                </Flex>
//             </Flex>
//          )}
//       </>
//    );
// };

// export default GSTR1;

'use client';
import { useState, useEffect, useCallback } from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useColorMode,
   Grid,
   GridItem,
   Popover,
   PopoverTrigger,
   PopoverContent,
   PopoverBody,
   Button,
   VStack,
   TabPanel,
   TabPanels,
   Tabs,
   Tab,
   TabList,
   MenuList,
   Menu,
   MenuButton,
} from '@chakra-ui/react';
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import {
   getB2BSales,
   getB2CLSales,
   getB2CSSales,
   getCDNRSales,
   getCDNURSales,
   getEXPSales,
   getEXEMPSales,
   getHSNB2BSales,
   getHSNB2CSales,
   getDOCSSales,
   generateAllGSTRReports,
   downloadGSTRExcelFile,
   generateGSTRExcel,
   exportGSTR1Json,
} from '../../../../redux/actions/reports';
import Card from 'components/card/Card';
import nodata from 'assets/img/nfts/no data.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import * as XLSX from 'xlsx-js-style';
import { SHEET_CONFIGS } from 'utils/util';
import { exportGSTR1ToExcel } from 'utils/util';
import { exportAllGSTR1Sheets } from 'utils/util';
import Loading from 'components/loading/Loading';
import { useUser } from 'contexts';
import { ChevronDownIcon } from '@chakra-ui/icons';

const GSTR1 = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const [fromDate, setFromDate] = useState('2025-04-14');
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const [selected, setSelected] = useState(null);
   const [selectedOption, setSelectedOption] = useState('B2B');
   const [isDownloading, setIsDownloading] = useState(false);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });
   const { user } = useUser();
   const financialYear = localStorage.getItem('selectedFinancialYear');

   const B2BSales = useSelector((state) => state.reports?.b2bSales || []);
   const B2CLSales = useSelector((state) => state.reports?.b2clSales || []);
   const B2CSSales = useSelector((state) => state.reports?.b2csSales || []);
   const CDNRSales = useSelector((state) => state.reports?.cdnrSales || []);
   const CDNURSales = useSelector((state) => state.reports?.cdnurSales || []);
   const EXPSales = useSelector((state) => state.reports?.expSales || []);
   const EXEMPSales = useSelector((state) => state.reports?.exempSales || []);
   const HSNB2BSales = useSelector((state) => state.reports?.hsnB2BSales || []);
   const HSNB2CSales = useSelector((state) => state.reports?.hsnB2CSales || []);
   const DOCSSales = useSelector((state) => state.reports?.docsSales || []);

   const dispatch = useDispatch();

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates;
      const formattedFrom = from ? new Date(from).toISOString().split('T')[0] : '';
      const formattedTo = to ? new Date(to).toISOString().split('T')[0] : '';

      setDateRange({
         fromDate: formattedFrom,
         toDate: formattedTo,
      });
   };

   const reportTypes = {
      B2B: {
         data: B2BSales,
         action: getB2BSales,
         columns: [
            { id: 'acc_gstin', header: 'GSTIN/UIN of Recipient', accessor: 'acc_gstin' },
            { id: 'accountname', header: 'Receiver Name', accessor: 'accountname' },
            { id: 'docnumber', header: 'Invoice Number', accessor: 'docnumber' },
            {
               id: 'txndate',
               header: 'Invoice Date',
               accessor: 'txndate',
               format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
            },
            { id: 'netamount', header: 'Invoice Value', accessor: 'netamount' },
            { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
            { id: 'reversecharge', header: 'Reverse Charge', accessor: 'reversecharge' },
            { id: 'applicableRate', header: 'Applicable % of Tax Rate', accessor: 'applicabletaxrate' },
            { id: 'invoicetype', header: 'Invoice Type', accessor: 'invoicetype' },
            { id: 'ecom_cust_gstin', header: 'E-Commerce GSTIN', accessor: 'ecom_cust_gstin' },
            { id: 'rate', header: 'Rate', accessor: '', staticValue: '18%' },
            { id: 'taxableamount', header: 'Taxable Value', accessor: 'taxableamount' },
            { id: 'cess', header: 'Cess Amount', accessor: 'cess' },
         ],
      },
      B2CL: {
         data: B2CLSales,
         action: getB2CLSales,
         columns: [
            { id: 'invno', header: 'Invoice Number', accessor: 'invno' },
            {
               id: 'invoicedate',
               header: 'Invoice Date',
               accessor: 'invoicedate',
               format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
            },
            { id: 'invoicevalue', header: 'Invoice Value', accessor: 'invoicevalue' },
            { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
            { id: 'applicabletaxrate', header: 'Applicable % of Tax Rate', accessor: 'applicabletaxrate' },
            { id: 'rate', header: 'Rate', accessor: '', staticValue: '18%' },
            { id: 'taxableamount', header: 'Taxable Value', accessor: 'taxableamount' },
            { id: 'cess', header: 'Cess Amount', accessor: 'cess' },
            { id: 'ecom_cust_gstin', header: 'E-Commerce GSTIN', accessor: 'ecom_cust_gstin' },
         ],
      },
      B2CS: {
         data: B2CSSales,
         action: getB2CSSales,
         columns: [
            { id: 'type', header: 'Type', accessor: 'type' },
            { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
            { id: 'applicabletaxrate', header: 'Applicable % Tax of Rate', accessor: 'applicabletaxrate' },
            { id: 'rate', header: 'Rate', accessor: '', staticValue: '18%' },
            { id: 'taxablevalue', header: 'Taxable Value', accessor: 'taxablevalue' },
            { id: 'cessamount', header: 'Cess Amount', accessor: 'cessamount' },
            { id: 'ecom_cust_gstin', header: 'E-Commerce GSTIN', accessor: 'ecom_cust_gstin' },
         ],
      },
      CDNR: {
         data: CDNRSales,
         action: getCDNRSales,
         columns: [
            { id: 'acc_gstin', header: 'GSTIN/UIN of Recipient', accessor: 'acc_gstin' },
            { id: 'accountname', header: 'Receiver Name', accessor: 'accountname' },
            { id: 'docnumber', header: 'Note Number ', accessor: 'docnumber' },
            { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
            { id: 'reversecharge', header: 'Reverse Charge', accessor: 'reversecharge' },
            { id: 'applicabletaxrate', header: 'Applicable % of Rate', accessor: 'applicabletaxrate' },
            { id: 'rate', header: 'Rate', accessor: 'rate' },
            { id: 'taxableamount', header: 'Taxable Value', accessor: 'taxableamount' },
            { id: 'cess', header: 'Cess Amount', accessor: 'cess' },
         ],
      },
      CDNUR: {
         data: CDNURSales,
         action: getCDNURSales,
         columns: [
            { id: 'UR Type', header: 'UR Type', accessor: 'UR Type' },
            { id: 'Note/Refund Voucher Number', header: 'Note Number', accessor: 'Note/Refund Voucher Number' },
            {
               id: 'Note/Refund Voucher Date',
               header: 'Note Date',
               accessor: 'Note/Refund Voucher Date',
               format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
            },
            { id: 'Document Type', header: 'Note type', accessor: 'Document Type' },
            { id: 'placeofsupply', header: 'Place Of Supply', accessor: 'placeofsupply' },
            { id: 'Note/Refund Voucher Value', header: 'Note Value', accessor: 'Note/Refund Voucher Value' },
            {
               id: 'Applicable % of Tax Rate',
               header: 'Applicable % of Tax Rate',
               accessor: 'Applicable % of Tax Rate',
            },
            { id: 'rate', header: 'Rate', accessor: 'rate' },
            { id: 'Taxable Value', header: 'Taxable Value', accessor: 'Taxable Value' },
            { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
         ],
      },
      EXP: {
         data: EXPSales,
         action: getEXPSales,
         columns: [
            { id: 'exportType', header: 'Export Type', accessor: 'exportType' },
            { id: 'docnumber', header: 'Invoice Number', accessor: 'docnumber' },
            {
               id: 'txndate',
               header: 'Invoice Date',
               accessor: 'txndate',
               format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
            },
            { id: 'netAmount', header: 'Invoice Value', accessor: 'netAmount' },
            { id: 'portCode', header: 'Port Code', accessor: 'portCode' },
            { id: 'shippingBillNumber', header: 'Shipping Bill Number', accessor: 'shippingBillNumber' },
            {
               id: 'shippingBillDate',
               header: 'Shipping Bill Date',
               accessor: 'shippingBillDate',
               format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
            },
            { id: 'rate', header: 'Rate', accessor: '', staticValue: '0%' },
            { id: 'taxableAmount', header: 'Taxable Value', accessor: 'taxableAmount' },
            { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
         ],
      },
      EXEMP: {
         data: EXEMPSales,
         action: getEXEMPSales,
         columns: [
            { id: 'description', header: 'Description', accessor: 'description' },
            { id: 'docnumber', header: 'Nil Rated Supplies', accessor: 'docnumber' },
            {
               id: 'txndate',
               header: 'Exempted',
               accessor: 'txndate',
               format: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
            },
            { id: 'netAmount', header: 'Non-GST Supplies', accessor: 'netAmount' },
         ],
      },
      HSNB2B: {
         data: HSNB2BSales,
         action: getHSNB2BSales,
         columns: [
            { id: 'Description', header: 'HSN Code', accessor: 'Description' },
            { id: 'Description', header: 'Description', accessor: 'Description' },
            { id: 'UQC', header: 'UQC', accessor: 'UQC' },
            { id: 'Total Quantity', header: 'Total Quantity', accessor: 'Total Quantity' },
            { id: 'Total Value', header: 'Total Value', accessor: 'Total Value' },
            { id: 'Rate', header: 'Rate', accessor: 'Rate' },
            { id: 'Taxable Value', header: 'Taxable Value', accessor: 'Taxable Value' },
            { id: 'Integrated Tax Amount', header: 'Integrated Tax Amount', accessor: 'Integrated Tax Amount' },
            { id: 'Central Tax Amount', header: 'Central Tax Amount', accessor: 'Central Tax Amount' },
            { id: 'State/UT Tax Amount', header: 'State/UT Tax Amount', accessor: 'State/UT Tax Amount' },
            { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
         ],
      },
      HSNB2C: {
         data: HSNB2CSales,
         action: getHSNB2CSales,
         columns: [
            { id: 'Description', header: 'HSN Code', accessor: 'Description' },
            { id: 'Description', header: 'Description', accessor: 'Description' },
            { id: 'UQC', header: 'UQC', accessor: 'UQC' },
            { id: 'Total Quantity', header: 'Total Quantity', accessor: 'Total Quantity' },
            { id: 'Total Value', header: 'Total Value', accessor: 'Total Value' },
            { id: 'Rate', header: 'Rate', accessor: 'Rate' },
            { id: 'Taxable Value', header: 'Taxable Value', accessor: 'Taxable Value' },
            { id: 'Integrated Tax Amount', header: 'Integrated Tax Amount', accessor: 'Integrated Tax Amount' },
            { id: 'Central Tax Amount', header: 'Central Tax Amount', accessor: 'Central Tax Amount' },
            { id: 'State/UT Tax Amount', header: 'State/UT Tax Amount', accessor: 'State/UT Tax Amount' },
            { id: 'Cess Amount', header: 'Cess Amount', accessor: 'Cess Amount' },
         ],
      },
      DOCS: {
         data: DOCSSales,
         action: getDOCSSales,
         columns: [
            { id: 'Nature  of Document', header: 'Nature of Document', accessor: 'Nature  of Document' },
            { id: 'Sr. No. From', header: 'Sr. No. From', accessor: 'Sr. No. From' },
            { id: 'Sr. No. To', header: 'Sr. No. To', accessor: 'Sr. No. To' },
            { id: 'Total Number', header: 'Total Number', accessor: 'Total Number' },
            { id: 'CANCELLED', header: 'Cancelled', accessor: 'CANCELLED', format: (val) => (val ? 'Yes' : 'No') },
         ],
      },
   };
   const companyId = (user && user?.loginhistory?.companyId) || localStorage.getItem('companyId');

   useEffect(() => {
      if (!companyId) {
         console.error('Company ID not found in localStorage');
         return;
      }

      const currentReport = reportTypes[selectedOption];
      if (currentReport?.action && user && user?.loginhistory?.companyId) {
         dispatch(
            currentReport.action({
               companyId: user && user?.loginhistory?.companyId,
               fromDate: dateRange?.fromDate || fromDate,
               toDate: dateRange?.toDate || toDate,
            }),
         );
      }
   }, [dispatch, selectedOption, dateRange, fromDate, toDate, companyId]);

   const downloadAllReports = async () => {
      setIsDownloading(true);

      try {
         const requestData = {
            gstNumber: 'currentGstNumber',
            dateRange: {
               fromDate: dateRange?.fromDate || fromDate,
               toDate: dateRange?.toDate || toDate,
            },
            companyId,
         };

         const result = await dispatch(generateAllGSTRReports(requestData));

         const { results, successCount, totalReports } = result;
         console.log('Generated Reports:', results);

         for (const report of results) {
            if (report.success && report.filePath) {
               await dispatch(downloadGSTRExcelFile(report.fileName, report.filePath));
            }
         }
      } catch (error) {
         console.error('Error generating all reports:', error);
         alert(`Error generating reports: ${error.message}`);
      } finally {
         setIsDownloading(false);
      }
   };

   const downloadExcel = async () => {
      const currentReport = reportTypes[selectedOption];
      setIsDownloading(true);

      try {
         await exportGSTR1ToExcel(selectedOption, currentReport.data, {
            fromDate: dateRange?.fromDate || fromDate,
            toDate: dateRange?.toDate || toDate,
         });
      } catch (error) {
         console.error('Error downloading Excel:', error);
         alert(`Error downloading Excel: ${error.message}`);
      } finally {
         setIsDownloading(false);
      }
   };

   const generateEnhancedJSON = (gstr3bData, baseGstData = {}) => {
      const gstReturn = {
         gstin: baseGstData.gstin || '',
         fp: baseGstData.fp || '',
         b2b: [],
         b2cl: [],
         b2cs: [],
         cdnr: [],
         cdnur: [],
         exp: [],
         hsn: {
            hsn_b2b: [],
            hsn_b2c: [],
         },
         doc_issue: baseGstData.doc_issue || {
            doc_det: [],
         },
      };

      const getValue = (value) => {
         if (value === null || value === undefined || value === '') return 0;
         return Number(value) || 0;
      };

      const generateInvoiceNumber = (index, type = 'SI') => {
         const date = new Date();
         const year = date.getFullYear().toString().slice(-2);
         const nextYear = (date.getFullYear() + 1).toString().slice(-2);
         return `${type}-${year}-${nextYear}-${(index + 1).toString().padStart(3, '0')}`;
      };

      const generateGSTIN = (stateCode = '24', index = 0) => {
         const prefixes = ['BTCPP', 'ABRPG', 'DDIPM', 'ACOPJ', 'FNRPS', 'BBIPT', 'GUEPM'];
         const numbers = ['5520Q3ZA', '1554H1ZP', '9620J1Z9', '1707D1Z0', '1470K1ZD', '5789F1Z3', '9783G1Z2'];
         const prefix = prefixes[index % prefixes.length] || 'ABCDE';
         const number = numbers[index % numbers.length] || '1234A1B2';
         return `${stateCode}${prefix}${number}`;
      };

      const createB2BEntry = (gstr3bEntry, index, isCredit = false) => {
         const taxableValue = getValue(gstr3bEntry.taxable_value);
         const cgstAmount = getValue(gstr3bEntry.cgst_amount);
         const sgstAmount = getValue(gstr3bEntry.sgst_amount);
         const igstAmount = getValue(gstr3bEntry.igst_amount);

         if (taxableValue === 0 && cgstAmount === 0 && sgstAmount === 0 && igstAmount === 0) {
            return null;
         }

         const totalTax = cgstAmount + sgstAmount + igstAmount;
         const rate = taxableValue > 0 ? Math.round((totalTax / taxableValue) * 100) : 5;

         const invoiceValue = taxableValue + totalTax;
         const invoiceNumber = generateInvoiceNumber(index);
         const gstin = generateGSTIN('24', index);

         const entry = {
            ctin: gstin,
         };

         if (isCredit) {
            entry.nt = [
               {
                  val: Math.abs(invoiceValue),
                  ntty: 'C',
                  nt_num: `SI-RT-${index + 34}`,
                  nt_dt: new Date().toLocaleDateString('en-GB').replace(/\//g, '-'),
                  pos: '24',
                  rchrg: 'N',
                  inv_typ: 'R',
                  itms: [
                     {
                        num: 1,
                        itm_det: {
                           txval: Math.abs(taxableValue),
                           rt: rate,
                           iamt: Math.abs(igstAmount),
                           camt: Math.abs(cgstAmount),
                           samt: Math.abs(sgstAmount),
                           csamt: 0,
                        },
                     },
                  ],
               },
            ];
         } else {
            entry.inv = [
               {
                  inum: invoiceNumber,
                  idt: new Date().toLocaleDateString('en-GB').replace(/\//g, '-'),
                  val: invoiceValue,
                  pos: '24',
                  rchrg: 'N',
                  inv_typ: 'R',
                  itms: [
                     {
                        num: 1,
                        itm_det: {
                           txval: taxableValue,
                           rt: rate,
                           iamt: igstAmount,
                           camt: cgstAmount,
                           samt: sgstAmount,
                           csamt: 0,
                        },
                     },
                  ],
               },
            ];
         }

         return entry;
      };

      const createHSNEntry = (gstr3bEntry, index, type = 'b2b') => {
         const taxableValue = getValue(gstr3bEntry.taxable_value);
         const cgstAmount = getValue(gstr3bEntry.cgst_amount);
         const sgstAmount = getValue(gstr3bEntry.sgst_amount);
         const igstAmount = getValue(gstr3bEntry.igst_amount);

         if (taxableValue === 0 && cgstAmount === 0 && sgstAmount === 0 && igstAmount === 0) {
            return null;
         }

         const totalTax = cgstAmount + sgstAmount + igstAmount;
         const rate = taxableValue > 0 ? Math.round((totalTax / taxableValue) * 100) : 5;

         const hsnCodes = ['5404', '540710', '6204', '6109', '5208'];
         const descriptions = ['YAMINI', 'aKSHARA (VI)', 'COTTON FABRIC', 'T-SHIRTS', 'WOVEN FABRIC'];
         const uqcs = ['QTL', 'PCS', 'MTR', 'PCS', 'MTR'];

         const hsnCode = hsnCodes[index % hsnCodes.length];
         const description = descriptions[index % descriptions.length];
         const uqc = uqcs[index % uqcs.length];

         const avgPrice = taxableValue > 0 ? Math.max(1, Math.round(taxableValue / 100)) : 100;
         const qty = Math.max(1, Math.round(taxableValue / avgPrice));

         return {
            num: index + 1,
            hsn_sc: type === 'b2c' ? hsnCode + '10' : hsnCode,
            txval: taxableValue,
            iamt: igstAmount,
            camt: cgstAmount,
            samt: sgstAmount,
            csamt: 0,
            desc: '',
            user_desc: type === 'b2c' ? '' : description,
            uqc: uqc,
            qty: qty,
            rt: rate,
         };
      };

      if (Array.isArray(gstr3bData)) {
         let b2bIndex = 0;
         let hsnB2BIndex = 0;
         let hsnB2CIndex = 0;
         let b2clIndex = 0;
         let b2csIndex = 0;

         gstr3bData.forEach((entry, index) => {
            const subpara = entry.subpara || '';
            const para = entry.para || '';
            const taxableValue = getValue(entry.taxable_value);

            if (taxableValue === 0 && getValue(entry.total_tax) === 0) {
               return;
            }

            if (
               subpara.includes('Outward taxable supplies') &&
               !subpara.includes('zero rated') &&
               !subpara.includes('Exempted')
            ) {
               const numEntries = Math.min(5, Math.max(1, Math.floor(taxableValue / 10000)));
               const valuePerEntry = taxableValue / numEntries;
               const cgstPerEntry = getValue(entry.cgst_amount) / numEntries;
               const sgstPerEntry = getValue(entry.sgst_amount) / numEntries;
               const igstPerEntry = getValue(entry.igst_amount) / numEntries;

               for (let i = 0; i < numEntries; i++) {
                  const b2bEntry = createB2BEntry(
                     {
                        taxable_value: valuePerEntry,
                        cgst_amount: cgstPerEntry,
                        sgst_amount: sgstPerEntry,
                        igst_amount: igstPerEntry,
                     },
                     b2bIndex + i,
                  );

                  if (b2bEntry) {
                     gstReturn.b2b.push(b2bEntry);
                  }
               }
               b2bIndex += numEntries;

               const hsnEntry = createHSNEntry(entry, hsnB2BIndex, 'b2b');
               if (hsnEntry) {
                  gstReturn.hsn.hsn_b2b.push(hsnEntry);
                  hsnB2BIndex++;
               }
            } else if (subpara.includes('zero rated') && taxableValue !== 0) {
               const hsnEntry = createHSNEntry(entry, hsnB2CIndex, 'b2c');
               if (hsnEntry) {
                  gstReturn.hsn.hsn_b2c.push(hsnEntry);
                  hsnB2CIndex++;
               }
            } else if (subpara.includes('B2CL') || para.includes('Unregistered Persons')) {
               const b2clEntry = createB2BEntry(entry, b2clIndex);
               if (b2clEntry) {
                  delete b2clEntry.ctin;
                  b2clEntry.pos = '24';
                  if (b2clEntry.inv) {
                     b2clEntry.inv[0].pos = '24';
                     b2clEntry.inv[0].val = getValue(entry.taxable_value) + getValue(entry.total_tax);
                  }
                  gstReturn.b2cl.push(b2clEntry);
                  b2clIndex++;
               }
            } else if (subpara.includes('B2CS')) {
               const rate =
                  getValue(entry.total_tax) > 0
                     ? Math.round((getValue(entry.total_tax) / getValue(entry.taxable_value)) * 100)
                     : 5;

               const b2csEntry = {
                  pos: '24',
                  txval: getValue(entry.taxable_value),
                  rt: rate,
                  iamt: getValue(entry.igst_amount),
                  camt: getValue(entry.cgst_amount),
                  samt: getValue(entry.sgst_amount),
                  csamt: 0,
               };

               gstReturn.b2cs.push(b2csEntry);
               b2csIndex++;
            } else if (subpara.includes('Credit') || subpara.includes('Debit')) {
               const creditEntry = createB2BEntry(entry, b2bIndex, true);
               if (creditEntry) {
                  gstReturn.b2b.push(creditEntry);
                  b2bIndex++;
               }
            } else if (subpara.includes('Export')) {
               const expEntry = createB2BEntry(entry, 0);
               if (expEntry && expEntry.inv) {
                  expEntry.inv[0].exp_typ = 'WPAY';
                  expEntry.inv[0].port_cd = 'INMAA4';
                  gstReturn.exp.push(expEntry);
               }
            }
         });
      }

      if (gstReturn.b2b.length > 0 && (!baseGstData.doc_issue || !baseGstData.doc_issue.doc_det)) {
         const firstInvoice = gstReturn.b2b.find((entry) => entry.inv)?.inv[0]?.inum;
         const lastInvoice = gstReturn.b2b[gstReturn.b2b.length - 1]?.inv?.[0]?.inum;

         if (firstInvoice) {
            gstReturn.doc_issue = {
               doc_det: [
                  {
                     doc_num: 1,
                     docs: [
                        {
                           cancel: 0,
                           from: firstInvoice,
                           net_issue: gstReturn.b2b.length,
                           num: 1,
                           to: lastInvoice || firstInvoice,
                           totnum: gstReturn.b2b.length,
                        },
                     ],
                  },
               ],
            };
         }
      }

      if (gstReturn.b2cl.length === 0) delete gstReturn.b2cl;
      if (gstReturn.b2cs.length === 0) delete gstReturn.b2cs;
      if (gstReturn.cdnr.length === 0) delete gstReturn.cdnr;
      if (gstReturn.cdnur.length === 0) delete gstReturn.cdnur;
      if (gstReturn.exp.length === 0) delete gstReturn.exp;
      if (gstReturn.hsn.hsn_b2b.length === 0 && gstReturn.hsn.hsn_b2c.length === 0) {
         delete gstReturn.hsn;
      } else {
         if (gstReturn.hsn.hsn_b2b.length === 0) delete gstReturn.hsn.hsn_b2b;
         if (gstReturn.hsn.hsn_b2c.length === 0) delete gstReturn.hsn.hsn_b2c;
      }

      return gstReturn;
   };

   const downloadJSON = (data, filename = 'gst_return_data.json') => {
      const jsonString = JSON.stringify(data, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url);

      console.log(`Downloaded: ${filename}`);
   };

   const handleGenerateEnhancedJSON = (gstr3bData, baseGstData = {}) => {
      try {
         if (!Array.isArray(gstr3bData) || gstr3bData.length === 0) {
            console.error('Invalid GSTR3B data provided');
            alert('Invalid GSTR3B data. Please provide valid array of GSTR3B entries.');
            return {};
         }

         console.log('Processing GSTR3B data:', gstr3bData);

         const gstReturnData = generateEnhancedJSON(gstr3bData, baseGstData);

         const timestamp = new Date().toISOString().split('T')[0];
         const filename = `gst_return_${gstReturnData.gstin || 'converted'}_${gstReturnData.fp || timestamp.replace(/-/g, '')
            }.json`;

         downloadJSON(gstReturnData, filename);

         console.log('GST Return JSON generated successfully');
         console.log('Generated structure:', Object.keys(gstReturnData));
         console.log('B2B entries:', gstReturnData.b2b?.length || 0);

         return gstReturnData;
      } catch (error) {
         console.error('Error generating GST Return JSON:', error);
         alert('Error generating JSON file. Check console for details.');
         return {};
      }
   };

   const onDownloadJson = useCallback(async () => {
      const res = await dispatch(exportGSTR1Json({ companyId, fromDate: '2025-10-01', toDate: '2025-10-31' }));
      const jsonString = JSON.stringify(res, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${res.gstin}_GSTR1.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
   }, [companyId, dispatch]);

   const Dynamicoption = ({ setSelectedOption, selectedOption }) => {
      const options = Object.keys(reportTypes);
      const tabs = options.map((option) => ({ value: option, label: option }));
      const currentIndex = options.indexOf(selectedOption);

      const prevTab = currentIndex > 0 ? { value: options[currentIndex - 1], label: options[currentIndex - 1] } : null;
      const nextTab =
         currentIndex < options.length - 1
            ? { value: options[currentIndex + 1], label: options[currentIndex + 1] }
            : null;

      const mobilePrevTab = prevTab;
      const mobileNextTab = nextTab;

      const getTabletTabs = () => {
         if (tabs.length <= 5) return tabs;
         if (currentIndex < 2) {
            return tabs.slice(0, 5);
         } else if (currentIndex > tabs.length - 3) {
            return tabs.slice(tabs.length - 5);
         } else {
            return tabs.slice(currentIndex - 2, currentIndex + 3);
         }
      };

      const tabletTabs = getTabletTabs();

      const handleClick = (option) => {
         setSelectedOption(option);
      };

      const MobileNavigation = () => (
         <>
            {/* Mobile View */}
            <div
               className={`md:hidden flex items-center justify-between p-3 rounded-lg mt-2 ${isDark ? 'bg-[#101F4A]' : 'bg-white shadow-sm'
                  }`}>
               <div className="flex items-center gap-2 w-[30%] justify-start text-sm font-medium">
                  {mobilePrevTab && (
                     <>
                        <button
                           onClick={() => mobilePrevTab && handleClick(mobilePrevTab.value)}
                           disabled={!mobilePrevTab}
                           className={`p-1 rounded transition-all ${mobilePrevTab
                                 ? `${isDark ? 'hover:bg-blue-900/30' : 'hover:bg-gray-100'} cursor-pointer`
                                 : 'opacity-50 cursor-not-allowed'
                              }`}>
                           <MdOutlineNavigateBefore size={20} className={isDark ? 'text-white' : 'text-gray-700'} />
                        </button>
                        <span className={isDark ? 'text-white' : 'text-gray-700'}>{mobilePrevTab.label}</span>
                     </>
                  )}
               </div>

               <div
                  className={`px-5 py-2.5 rounded-2xl text-sm font-bold text-white shadow-lg transition-all duration-300 w-[30%] text-center ${isDark
                        ? 'bg-gradient-to-r from-[#4F46E5] via-[#7C3AED] to-[#EC4899] border border-purple-500/30'
                        : 'bg-gradient-to-r from-[#10B981] to-[#06B6D4] border border-teal-400/30'
                     }`}>
                  {selectedOption}
               </div>

               <div className="flex items-center gap-2 w-[30%] justify-end text-sm font-medium">
                  {mobileNextTab && (
                     <>
                        <span className={isDark ? 'text-white' : 'text-gray-700'}>{mobileNextTab.label}</span>
                        <button
                           onClick={() => mobileNextTab && handleClick(mobileNextTab.value)}
                           disabled={!mobileNextTab}
                           className={`p-1 rounded transition-all ${mobileNextTab
                                 ? `${isDark ? 'hover:bg-blue-900/30' : 'hover:bg-gray-100'} cursor-pointer`
                                 : 'opacity-50 cursor-not-allowed'
                              }`}>
                           <MdOutlineNavigateNext size={20} className={isDark ? 'text-white' : 'text-gray-700'} />
                        </button>
                     </>
                  )}
               </div>
            </div>

            {/* Tablet View */}
            <div
               className={`hidden md:flex lg:hidden items-center justify-between p-2 rounded-lg mt-2 ${isDark ? 'bg-[#101F4A]' : 'bg-white shadow-sm'
                  }`}>
               <button
                  onClick={() => currentIndex > 0 && handleClick(options[currentIndex - 1])}
                  disabled={currentIndex === 0}
                  className={`p-2 rounded transition-all ${currentIndex > 0
                        ? `${isDark ? 'hover:bg-blue-900/30' : 'hover:bg-gray-100'} cursor-pointer`
                        : 'opacity-50 cursor-not-allowed'
                     }`}>
                  <MdOutlineNavigateBefore size={20} className={isDark ? 'text-white' : 'text-gray-700'} />
               </button>

               {tabletTabs.map((tab) => (
                  <button
                     key={tab.value}
                     onClick={() => handleClick(tab.value)}
                     className={`flex-1 px-5 py-2.5 rounded-2xl text-sm font-bold transition-all duration-300 ${tab.value === selectedOption
                           ? isDark
                              ? 'bg-gradient-to-r from-[#4F46E5] via-[#7C3AED] to-[#EC4899] text-white shadow-lg shadow-purple-500/40 border border-purple-500/30'
                              : 'bg-gradient-to-r from-[#10B981] to-[#06B6D4] text-white shadow-lg shadow-teal-400/40 border border-teal-400/30'
                           : isDark
                              ? 'text-gray-400 hover:bg-blue-900/20 hover:text-white'
                              : 'text-gray-500 hover:bg-gray-100 hover:text-gray-900'
                        }`}>
                     {tab.label}
                  </button>
               ))}

               <button
                  onClick={() => currentIndex < options.length - 1 && handleClick(options[currentIndex + 1])}
                  disabled={currentIndex === options.length - 1}
                  className={`p-2 rounded transition-all ${currentIndex < options.length - 1
                        ? `${isDark ? 'hover:bg-blue-900/30' : 'hover:bg-gray-100'} cursor-pointer`
                        : 'opacity-50 cursor-not-allowed'
                     }`}>
                  <MdOutlineNavigateNext size={20} className={isDark ? 'text-white' : 'text-gray-700'} />
               </button>
            </div>
         </>
      );

      return (
         <>
            <MobileNavigation />

            {/* Desktop View */}
            <div
               className={`lg:flex p-3 rounded-2xl gap-3 ${isDark
                     ? 'bg-[#1a2744]/50 backdrop-blur-sm border border-blue-900/20'
                     : 'bg-white/80 backdrop-blur-sm shadow-sm border border-gray-200/50'
                  }`}>
               {options.map((option, index) => (
                  <button
                     key={index}
                     onClick={() => setSelectedOption(option)}
                     className={`flex-1 py-3 px-6 rounded-2xl text-sm font-bold transition-all duration-300 transform hover:scale-105 ${selectedOption === option
                           ? isDark
                              ? 'bg-gradient-to-r from-[#4F46E5] via-[#7C3AED] to-[#EC4899] text-white shadow-xl shadow-purple-500/50 border border-purple-500/30 scale-105'
                              : 'bg-gradient-to-r from-[#10B981] to-[#06B6D4] text-white shadow-xl shadow-teal-400/50 border border-teal-400/30 scale-105'
                           : isDark
                              ? 'text-gray-400 hover:bg-blue-900/30 hover:text-white bg-[#0A1628]/50'
                              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900 bg-gray-50/50'
                        }`}>
                     {option}
                  </button>
               ))}
            </div>
         </>
      );
   };

   const DynamicSummary = ({ data }) => {
      const totalInvoices = data.length;
      const totalInvoiceValue = data.reduce((sum, invoice) => sum + (parseFloat(invoice.netAmount) || 0), 0);
      const totalTaxableValue = data.reduce((sum, taxable) => sum + (parseFloat(taxable.taxableAmount) || 0), 0);

      return (
         <div
            className={`rounded-lg p-4 mb-1 ${isDark ? 'bg-[#101F4A] border border-blue-900/30' : 'bg-white shadow-md'
               }`}>
            <h3 className={`text-base font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>Summary</h3>

            <div className="flex flex-wrap gap-8">
               <div className={`flex gap-12 pr-8 border-r ${isDark ? 'border-blue-800/50' : 'border-gray-200'}`}>
                  <div className="text-center">
                     <p className={`text-sm font-semibold  ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                        No. of {selectedOption === 'B2B' ? 'Recipients' : 'Invoices'}
                     </p>
                     <p className={`text-2xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>{data.length}</p>
                  </div>

                  <div className="text-center">
                     <p className={`text-sm font-semibold ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                        No. of Invoices
                     </p>
                     <p className={`text-2xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                        {totalInvoices}
                     </p>
                  </div>
               </div>

               <div className="flex gap-12 pl-8">
                  <div className="text-center">
                     <p className={`text-sm font-semibold ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                        Total Invoice Value
                     </p>
                     <p className={`text-2xl font-bold ${isDark ? 'text-emerald-400' : 'text-emerald-600'}`}>
                        ₹{totalInvoiceValue.toFixed(2)}
                     </p>
                  </div>

                  <div className="text-center">
                     <p className={`text-sm font-semibold ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                        Total Taxable Value
                     </p>
                     <p className={`text-2xl font-bold ${isDark ? 'text-emerald-400' : 'text-emerald-600'}`}>
                        ₹{totalTaxableValue.toFixed(2)}
                     </p>
                  </div>
               </div>
            </div>
         </div>
      );
   };

   const renderTable = () => {
      const currentReport = reportTypes[selectedOption];
      if (!currentReport) return null;

      return (
         <div
            className={`mt-4 rounded-lg overflow-hidden ${isDark ? 'bg-[#101F4A] border border-blue-900/30' : 'bg-white shadow-md'
               }`}>
            <div className="overflow-x-auto custom-scrollbar" style={{ minHeight: '60vh', maxHeight: '60vh' }}>
               <table className="w-full">
                  <thead className={`sticky top-0 z-2 ${isDark ? 'bg-[#0A1628]' : 'bg-gray-50'}`}>
                     <tr>
                        {currentReport.columns.map((column, index) => (
                           <th
                              key={index}
                              className={`px-4 py-4 text-left text-xs font-semibold uppercase tracking-wider ${isDark
                                    ? 'text-gray-300 border-b border-blue-900/30'
                                    : 'text-gray-700 border-b border-gray-200'
                                 }`}>
                              {column.header}
                           </th>
                        ))}
                     </tr>
                  </thead>
                  <tbody>
                     {currentReport.data.length === 0 ? (
                        <tr>
                           <td colSpan={currentReport.columns.length} className="text-center py-16">
                              <div className="flex flex-col items-center justify-center gap-6">
                                 <img src={nodata} alt="No Data Found" className="w-48 h-48 opacity-75" />
                                 <p className={`text-lg font-medium ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                    No {selectedOption} data found
                                 </p>
                              </div>
                           </td>
                        </tr>
                     ) : (
                        currentReport.data.map((row, rowIndex) => (
                           <tr
                              key={rowIndex}
                              className={`transition-colors ${isDark
                                    ? 'hover:bg-blue-900/20 border-b border-blue-900/20'
                                    : 'hover:bg-blue-50 border-b border-gray-100'
                                 }`}>
                              {currentReport.columns.map((column, colIndex) => (
                                 <td
                                    key={colIndex}
                                    className={`px-4 py-3 text-sm ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    {column.accessor
                                       ? column.format
                                          ? column.format(row[column.accessor])
                                          : row[column.accessor] !== undefined
                                             ? row[column.accessor]
                                             : '-'
                                       : column.staticValue || '-'}
                                 </td>
                              ))}
                           </tr>
                        ))
                     )}
                  </tbody>
               </table>
            </div>
         </div>
      );
   };

   const MonthQuarterDropdown = ({ setDateRange, selected, setSelected }) => {
      const financialYear = localStorage.getItem('selectedFinancialYear');
      const [startYear, endYear] = financialYear?.split('-').map((y) => parseInt(y.trim(), 10));

      const months = [
         `April ${startYear}`,
         `May ${startYear}`,
         `June ${startYear}`,
         `July ${startYear}`,
         `August ${startYear}`,
         `September ${startYear}`,
         `October ${startYear}`,
         `November ${startYear}`,
         `December ${startYear}`,
         `January ${endYear}`,
         `February ${endYear}`,
         `March ${endYear}`,
      ];

      const quarters = [
         `Q1  ( April ${startYear} - June ${startYear} )`,
         `Q2  ( July ${startYear} - September ${startYear} )`,
         `Q3  ( October ${startYear} - December ${startYear} )`,
         `Q4 ( January ${endYear} - March ${endYear} )`,
      ];

      const handleDateRangeChange = (option, type) => {
         if (type === 'month') {
            const [monthName, year] = option.split(' ');
            const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
            const fromDate = new Date(year, monthIndex, 1, 0, 0, 1);
            const toDate = new Date(year, monthIndex + 1, 0);

            setDateRange({
               fromDate: fromDate.toLocaleDateString('en-CA'),
               toDate: toDate.toLocaleDateString('en-CA'),
            });
         }
         if (type === 'quarter') {
            const match = option.match(/\((.*?)\)/);
            if (match) {
               const [startStr, endStr] = match[1].split('-').map((s) => s.trim());

               const [startMonthName, startYear] = startStr.split(' ');
               const startMonthIndex = new Date(`${startMonthName} 1, ${startYear}`).getMonth();
               const fromDate = new Date(startYear, startMonthIndex, 1, 0, 0, 1);

               const [endMonthName, endYear] = endStr.split(' ');
               const endMonthIndex = new Date(`${endMonthName} 1, ${endYear}`).getMonth();
               const toDate = new Date(endYear, endMonthIndex + 1, 0, 23, 59, 59);

               setDateRange({
                  fromDate: fromDate.toLocaleDateString('en-CA'),
                  toDate: toDate.toLocaleDateString('en-CA'),
               });
            }
         }
         setSelected(option);
      };

      return (
         <Menu closeOnSelect={false}>
            {({ onClose }) => (
               <>
                  <MenuButton
                     as={Button}
                     rightIcon={<ChevronDownIcon />}
                     className={`w-64 justify-between text-left ${isDark
                           ? 'bg-[#101F4A] text-white border border-blue-900/30 hover:bg-blue-900/20'
                           : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                        }`}>
                     {selected || 'Select Option'}
                  </MenuButton>

                  <MenuList
                     p={0}
                     minW="250px"
                     className={isDark ? 'bg-[#101F4A] border border-blue-900/30' : 'bg-white'}>
                     <Tabs isFitted variant="enclosed">
                        <TabList className={isDark ? 'border-b border-blue-900/30' : 'border-b border-gray-200'}>
                           <Tab
                              className={`${isDark
                                    ? 'text-gray-300 _selected:text-white _selected:bg-blue-900/30'
                                    : 'text-gray-600'
                                 }`}>
                              Month
                           </Tab>
                           <Tab
                              className={`${isDark
                                    ? 'text-gray-300 _selected:text-white _selected:bg-blue-900/30'
                                    : 'text-gray-600'
                                 }`}>
                              Quarter
                           </Tab>
                        </TabList>

                        <TabPanels>
                           <TabPanel maxH="400px" overflowY="auto" p={0}>
                              <VStack align="stretch" gap={0}>
                                 {months.map((month) => (
                                    <Button
                                       key={month}
                                       variant="ghost"
                                       justifyContent="flex-start"
                                       borderRadius={0}
                                       onClick={() => {
                                          handleDateRangeChange(month, 'month');
                                          setSelected(month);
                                          onClose();
                                       }}
                                       className={`${isDark
                                             ? 'text-gray-300 hover:bg-blue-900/20 hover:text-white'
                                             : 'text-gray-700 hover:bg-blue-100'
                                          }`}>
                                       {month}
                                    </Button>
                                 ))}
                              </VStack>
                           </TabPanel>

                           <TabPanel maxH="400px" overflowY="auto" p={0}>
                              <VStack align="stretch" gap={0}>
                                 {quarters.map((q) => (
                                    <Button
                                       key={q}
                                       variant="ghost"
                                       justifyContent="flex-start"
                                       borderRadius={0}
                                       onClick={() => {
                                          handleDateRangeChange(q, 'quarter');
                                          setSelected(q);
                                          onClose();
                                       }}
                                       className={`${isDark
                                             ? 'text-gray-300 hover:bg-blue-900/20 hover:text-white'
                                             : 'text-gray-700 hover:bg-blue-100'
                                          }`}>
                                       {q}
                                    </Button>
                                 ))}
                              </VStack>
                           </TabPanel>
                        </TabPanels>
                     </Tabs>
                  </MenuList>
               </>
            )}
         </Menu>
      );
   };

   return (
      <div
         className={`min-h-scree p-2 mt-10 ${isDark ? 'bg-gradient-to-br from-[#0A1628] to-[#1a2744]' : 'bg-gradient-to-br from-gray-50 to-gray-100'
            }`}>
         {/* Header */}
         <div className="flex justify-between items-center ">
            <div className="flex items-center gap-4">
               <button
                  onClick={() => window.history.back()}
                  className={`p-2 rounded-lg transition-all ${isDark ? 'hover:bg-blue-900/30 active:scale-95' : 'hover:bg-gray-200 active:scale-95'
                     }`}>
                  <img src={back} alt="Go Back" className="w-4 h-4" />
               </button>
               <h1 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>GSTR1</h1>
            </div>

            <div className="flex items-center gap-4">
               {financialYear === 'ALL' ? (
                  <PeriodDatePicker
                     value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                     onChange={handleDateRangeChange}
                     defaultPeriod="lastMonth"
                     style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                  />
               ) : (
                  <MonthQuarterDropdown setDateRange={setDateRange} selected={selected} setSelected={setSelected} />
               )}

               <Popover>
                  <PopoverTrigger>
                     <button
                        className={`p-2 rounded-lg transition-all ${isDark ? 'hover:bg-blue-900/30 active:scale-95' : 'hover:bg-gray-200 active:scale-95'
                           }`}>
                        <img src={Download} alt="Download" className="w-7 h-7" />
                     </button>
                  </PopoverTrigger>

                  <PopoverContent
                     width="220px"
                     zIndex="10"
                     className={`${isDark ? 'bg-[#101F4A] border border-blue-900/30' : 'bg-white shadow-xl'}`}>
                     <PopoverBody p="3">
                        <button
                           onClick={downloadExcel}
                           disabled={isDownloading}
                           className={`w-full flex items-center justify-between px-4 py-3 rounded-lg mb-3 transition-all ${isDark ? 'hover:bg-blue-900/30 text-white' : 'hover:bg-blue-50 text-gray-700'
                              } ${isDownloading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
                           <img src={xls} alt="Download XLS" className="w-7 h-7" />
                           <span className="font-medium">Download Excel</span>
                        </button>

                        <button
                           onClick={onDownloadJson}
                           disabled={isDownloading}
                           className={`w-full flex items-center justify-between px-4 py-3 rounded-lg transition-all ${isDark ? 'hover:bg-blue-900/30 text-white' : 'hover:bg-blue-50 text-gray-700'
                              } ${isDownloading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
                           <img src={json} alt="Download JSON" className="w-7 h-7" />
                           <span className="font-medium">Download JSON</span>
                        </button>
                     </PopoverBody>
                  </PopoverContent>
               </Popover>
            </div>
         </div>

         {/* Dynamic Options */}
         <div className="mt-4">
            <Dynamicoption selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
         </div>

         {/* Summary */}
         <div className="mt-4">
            <DynamicSummary data={reportTypes[selectedOption]?.data || []} />
         </div>

         {/* Table */}
         {renderTable()}

         {/* Loading Overlay */}
         {isDownloading && (
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[9999]">
               <div className={`p-8 rounded-xl shadow-2xl ${isDark ? 'bg-[#101F4A]' : 'bg-white'}`}>
                  <Loading />
               </div>
            </div>
         )}
      </div>
   );
};

export default GSTR1;
